import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Modal, Tabs, Tooltip } from "antd";

import List from "../../../../../components/List";
import {
  clearNotificacaoImportacao,
  getHistoricoImportacao,
  getNotificacaoImportacao,
} from "../actions";

import { changeConfiguration } from "../../../InfoCompany/Configuration/actions";

const { TabPane } = Tabs;

function Notificacao() {
  const dispatch = useDispatch();
  const { notificacao, isFetching } = useSelector((state) => state.importacao);

  const idImportacao = notificacao?.idImportacao;

  const doGetNotificacao = (tipo, page, pageSize) => {
    dispatch(getNotificacaoImportacao(idImportacao, tipo, { page, pageSize }));
  };

  const doFecharModal = () => {
    dispatch(clearNotificacaoImportacao());
    dispatch(getHistoricoImportacao());
  };

  const doChangeConfiguration = (configId, idImportacao, statusConfig) => {
    return changeConfiguration(configId, idImportacao, statusConfig).finally(
      () => doFecharModal()
    );
  };

  const doAlterarConfiguracao = (item) => {
    let configId = 0;
    let statusConfig = true;
    let message = null;
    switch (item.Codigo) {
      case "300":
        configId = 1;
        message = `Detectamos documentos fiscais eletrônicos sem validade jurídica, ou seja, sem 
          autorização de uso pela SEFAZ. Deseja realizar análise utilizando arquivos XML sem 
          validade jurídica?`;
        break;
      case "400":
        configId = 2;
        message = `O Período de Apuração carregado ultrapassa os últimos 5 anos. Deseja aceitar 
          arquivos com períodos maiores que 5 anos?`;
        break;
      case "401":
        configId = 3;
        statusConfig = false;
        message = `No extrato do Simples Nacional foi declarada imunidade tributária referente ao 
          PIS/Pasep, apesar de haver valor de COFINS a pagar. Estão incluídos nas imunidades 
          objetivas de tributos incluídos no Simples Nacional o PIS/Pasep e COFINS sobre receitas 
          relativas a exportações. Neste caso, não pode haver imunidade do PIS/Pasep e não haver 
          imunidade da COFINS. Deseja prosseguir na apuração de eventuais créditos de COFINS?`;
        break;
      case "301":
        configId = 4;
        message = `Detectamos documentos com CRT (Código de Regime Tributário) diferente de 1 ou 2 
          (Simples Nacional). Este módulo do e-Recuperador foi desenvolvido para empresas optantes 
          pelo Simples Nacional. Deseja prosseguir mesmo assim?`;
        break;
      default:
        message = null;
        break;
    }

    if (message) {
      Modal.confirm({
        title: "",
        content: message,
        cancelText: "Não",
        okText: "Sim",
        onOk: () =>
          doChangeConfiguration(configId, item.IdImportacao, statusConfig),
        onCancel: () =>
          doChangeConfiguration(configId, item.IdImportacao, !statusConfig),
      });
    }
  };

  return (
    <Modal
      title="Notificações"
      visible={!!notificacao}
      width={750}
      footer={null}
      onCancel={() => doFecharModal()}
    >
      <Tabs
        defaultActiveKey={notificacao?.tipo1?.Resultado.length > 0 ? "1" : "2"}
      >
        <TabPane tab="Sem ações" key="1">
          <List
            height="500px"
            loading={isFetching}
            dataSource={notificacao?.tipo1?.Resultado}
            pagination={{
              pageSize: 100,
              total: notificacao?.tipo1?.Paginacao?.Total,
              onChange: (page, pageSize) => doGetNotificacao(1, page, pageSize),
              onShowSizeChange: (page, pageSize) =>
                doGetNotificacao(1, page, pageSize),
            }}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={
                    <span dangerouslySetInnerHTML={{ __html: item.Mensagem }} />
                  }
                  description={item.NomeArquivo}
                />
              </List.Item>
            )}
          />
        </TabPane>
        <TabPane tab="Com ações" key="2">
          <List
            height="500px"
            loading={isFetching}
            dataSource={notificacao?.tipo2?.Resultado}
            pagination={{
              pageSize: 100,
              total: notificacao?.tipo2?.Paginacao?.Total,
              onChange: (page, pageSize) => doGetNotificacao(2, page, pageSize),
              onShowSizeChange: (page, pageSize) =>
                doGetNotificacao(2, page, pageSize),
            }}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={
                    <span dangerouslySetInnerHTML={{ __html: item.Mensagem }} />
                  }
                />
                <Tooltip title="Altera configuração relacionada">
                  <Button onClick={() => doAlterarConfiguracao(item)}>
                    Configurar
                  </Button>
                </Tooltip>
              </List.Item>
            )}
          />
        </TabPane>
      </Tabs>
    </Modal>
  );
}

export default Notificacao;
